import { render, staticRenderFns } from "./ManagedReports.vue?vue&type=template&id=6174fb1b&"
import script from "./ManagedReports.vue?vue&type=script&lang=js&"
export * from "./ManagedReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports